export const appConfig = {
  baseUrl: process.env.REACT_APP_SERVER_BASE_URL,
  website: "https://wabm.in",
};

export const awsBucketConfig = {
  openUploadedFilePrefix: `https://wabmate-general.s3.ap-south-1.amazonaws.com/`,
};
